import React, { useEffect, useState, useCallback } from "react";
import AdminAppBar from "../components/adminComponents/AdminAppBar";
import { GoPerson } from "react-icons/go";
import { 
  MdKeyboardArrowRight, 
  MdClose, 
  MdUpgrade, 
  MdLock,
  MdDashboard,
  MdApps
} from "react-icons/md";
import { RiLogoutCircleRLine, RiMenu3Line } from "react-icons/ri";
import {
  IoSettingsOutline,
  IoSunnySharp,
  IoPartlySunnySharp,
  IoLockClosed,
  IoNotificationsOutline,
  IoShieldCheckmarkOutline
} from "react-icons/io5";
import { MdOutlineDashboardCustomize } from "react-icons/md";
import Images from "../PropertyProcurementComponents/Constants/Images";
import { BsBell, BsStarFill } from "react-icons/bs";
import { 
  FaCloudSun, 
  FaPlay, 
  FaHeadphones, 
  FaYoutube,
  FaCrown,
  FaRocket
} from "react-icons/fa6";
import { FaQuestionCircle, FaCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getBasePathByUserRole } from "../utils/roleRoutes";
import { accessModule, userRole } from "../utils/storage";

const UserNavigationSystem = ({ isOpen, onClose }) => {
  const [greeting, setGreeting] = useState({});
  const [hoveredApp, setHoveredApp] = useState(null);
  const [activeSection, setActiveSection] = useState("modules");
  const [isClosing, setIsClosing] = useState(false);
  const navigate = useNavigate();
  const path = getBasePathByUserRole();

  // Get user data from localStorage with error handling
  const getUserData = useCallback(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      return {
        name: userData?.user?.name || "User",
        email: userData?.user?.email || "",
        avatar: userData?.user?.avatar || null,
        planType: userData?.planType || "Free"
      };
    } catch (error) {
      console.warn("Error parsing user data:", error);
      return { name: "User", email: "", avatar: null, planType: "Free" };
    }
  }, []);

  const user = getUserData();

  const systemNavigation = [
    // {
    //   image: Images.PropertyProcurementImage,
    //   label: "Property Procurement",
    //   navigate: "/propertyprocurement-list",
    //  // isActive: accessModule.propertyProcurementModule,
    //  isActive: true,
    //   planType: "Premium",
    //   description: "Manage your property procurement process efficiently",
    //   category: "Business Operations",
    //   color: "bg-blue-500"
    // },
    {
      image: Images.GLImage,
      label: "GL Funnel CRM",
      navigate: `${path}/dashboard`,
    //  isActive: accessModule.glFunnelModule,
      isActive: true,
      planType: "Standard",
      description: "Complete CRM solution for lead management",
      category: "Sales & Marketing",
      color: "bg-green-500",
    },
    // {
    //   image: Images.TaskImage,
    //   label: "Task Manager",
    //   navigate: null,
    //   isActive: accessModule.taskManagerModule,
    //   planType: "Premium",
    //   description: "Organize and track your team's tasks",
    //   upgradeMessage: "Upgrade to Premium to access Task Manager",
    //   category: "Productivity",
    //   color: "bg-purple-500",
    // },
    // {
    //   image: Images.AccountImage,
    //   label: "Accounts Pro",
    //   navigate: null,
    //   isActive: accessModule.accountsProModule,
    //   planType: "Enterprise",
    //   description: "Advanced accounting and financial management",
    //   upgradeMessage: "Upgrade to Enterprise plan for Accounts Pro",
    //   category: "Finance",
    //   color: "bg-orange-500",
    // },
    // {
    //   image: Images.HRImage,
    //   label: "HR Management",
    //   navigate: "/hr-employee-analytics",
    //   //isActive: accessModule.hrModule,
    //   isActive: true,
    //   planType: "Standard",
    //   description: "Human resource management system",
    //   category: "Human Resources",
    //   color: "bg-pink-500",
    // },
    // {
    //   image: Images.GEOImage,
    //   label: "GEO Tracking",
    //   navigate: "/geo-location-dashboard",
    //  // isActive: accessModule.geoGoModule,
    //  isActive: true,
    //   planType: "Premium",
    //   description: "Advanced location tracking and analytics",
    //   category: "Analytics",
    //   color: "bg-indigo-500",
    // },
    {
      image: Images.HRImage,
      label: "Global Setup",
      navigate: "/global-setup",
      isActive: true,
      planType: "Standard",
      description: "Global configurations and settings",
      category: "Settings",
      color: "bg-gray-500",
    },
  ];

  const supportItems = [
    {
      icon: <FaPlay className="text-blue-500" />,
      label: "Help Videos",
      navigate: "/help-videos",
      description: "Video tutorials and guides"
    },
    {
      icon: <FaHeadphones className="text-green-500" />,
      label: "Customer Support",
      navigate: "/customer-support",
      description: "24/7 support assistance"
    },
    {
      icon: <FaQuestionCircle className="text-purple-500" />,
      label: "What's New",
      badge: "3",
      navigate: "/whats-new",
      description: "Latest features and updates"
    },
    {
      icon: <FaYoutube className="text-red-500" />,
      label: "YouTube Channel",
      navigate: "/youtube-channel",
      description: "Educational content and demos"
    },
  ];

  const navigation = [
    { 
      id: "modules", 
      label: "Apps", 
      icon: <MdApps className="text-lg" />,
     
    },
    // { 
    //   id: "support", 
    //   label: "Support", 
    //   icon: <FaHeadphones className="text-lg" />,
     
    // },
  ];

  const handleAppClick = useCallback((app) => {
    if (app.isActive && app.navigate) {
      navigate(app.navigate);
      handleClose();
    } else if (!app.isActive) {
      // TODO: Show upgrade modal instead of console.log
      console.log(`Please upgrade to ${app.planType} plan to access ${app.label}`);
    }
  }, [navigate]);

  const handleNavigation = useCallback((path) => {
    navigate(path);
    handleClose();
  }, [navigate]);

  const handleClose = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 200);
  }, [onClose]);

  const handleSignOut = ()=>{
    localStorage.clear();
    navigate('/');
    window.location.reload();
  }
 

 
  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isOpen) return;
      
      if (event.key === "Escape") {
        handleClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, handleClose]);

  const filterModule =  systemNavigation.filter(app => app.isActive);

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className={`fixed inset-0 bg-black transition-opacity duration-300 z-40 ${
            isClosing ? "bg-opacity-0" : "bg-opacity-50"
          }`}
          onClick={handleClose}
          aria-label="Close navigation"
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-[420px] bg-white shadow-2xl z-50 transform transition-all duration-300 ease-out ${
          isOpen && !isClosing ? "translate-x-0" : "translate-x-full"
        }`}
        role="navigation"
        aria-label="User navigation system"
      >
        {/* Header with Greeting */}
        <div className={`relative p-6 bg-gradient-to-br ${greeting.gradient || "from-green-400 to-blue-500"} overflow-hidden`}>
          {/* Close Button */}
        
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full border-2 border-white"></div>
            <div className="absolute top-20 -right-5 w-20 h-20 rounded-full border border-white"></div>
          </div>

          {/* User Info */}
          <div className="relative">
            <div className="flex items-center gap-4 mb-4">
              {/* Avatar */}
              <div className="relative">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm border-2 border-white/30 text-white text-xl font-bold">
                  {user.avatar ? (
                    <img src={user.avatar} alt="User avatar" className="w-full h-full rounded-full object-cover" />
                  ) : (
                    user.name?.charAt(0).toUpperCase()
                  )}
                </div>
              
              </div>

              {/* User Details */}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="text-lg font-semibold text-white truncate">{user.name}</h4>
                
                </div>
                <p className="text-sm text-white/80 truncate">{userRole}</p>
                {user.email && (
                  <p className="text-xs text-white/60 truncate">{user.email}</p>
                )}
              </div>
            </div>


          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="border-b border-gray-200 bg-gray-50">
          <div className="flex">
            {navigation.map((item) => (
              <button
                key={item.id}
                onClick={() => setActiveSection(item.id)}
                className={`relative flex-1 px-4 py-3 text-sm font-medium transition-all duration-200 ${
                  activeSection === item.id
                    ? "text-blue-600 bg-white shadow-sm"
                    : "text-gray-600 hover:text-gray-800 hover:bg-white/50"
                }`}
              >
                <div className="flex items-center justify-center gap-2">
                  {item.icon}
                  <span>{item.label}</span>
                  
                </div>
                {activeSection === item.id && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></div>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-y-auto">
          {/* Modules Section */}
          {activeSection === "modules" && (
            <div className="p-6">
              {/* Profile Quick Access */}
              <div className="mb-6">
                <button
                  onClick={() => handleNavigation(`${path}/my-profile`)}
                  className="w-full flex items-center gap-3 p-4 rounded-xl border-2 border-blue-200 hover:border-blue-300 hover:bg-blue-50 transition-all duration-200 text-left group"
                >
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 group-hover:bg-blue-200 transition-colors duration-200">
                    <GoPerson className="text-blue-600 text-lg" />
                  </div>
                  <div className="flex-1">
                    <span className="text-gray-800 font-semibold">My Profile</span>
                    <p className="text-sm text-gray-500">View your profile settings</p>
                  </div>
                  <MdKeyboardArrowRight className="text-gray-400 group-hover:text-blue-600 transition-colors duration-200" />
                </button>
<div className="flex items-center gap-3">

<button
                  onClick={() => {
                    localStorage.clear();
                    navigate("/");
                    window.location.reload();
                  }}
                  className="w-full flex items-center gap-3 p-4 mt-4 rounded-xl border-2 border-red-200 hover:border-red-300 hover:bg-red-50 transition-all duration-200 text-left group"
                >
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 group-hover:bg-red-200 transition-colors duration-200">
                    <RiLogoutCircleRLine className="text-red-600 text-lg" />
                  </div>
                  <div className="flex-1">
                    <span className="text-gray-800 font-medium">Sign Out</span>
                    <p className="text-sm text-gray-500"></p>
                  </div>
                                </button>
                                <button
                  onClick={() => {
                 
                    navigate("/dashboard");
                   
                  }}
                  className="w-full flex items-center gap-3 p-4 mt-4 rounded-xl border-2 border-green-200 hover:border-green-300 hover:bg-green-50 transition-all duration-200 text-left group"
                >
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-green-100 group-hover:bg-green-200 transition-colors duration-200">
                    <MdOutlineDashboardCustomize className="text-green-600 text-lg" />
                  </div>
                  <div className="flex-1">
                    <span className="text-gray-800 font-medium">Dashboard</span>
                    <p className="text-sm text-gray-500"></p>
                  </div>
                                </button>
</div>

              </div>

              {/* Active Apps */}
              <div className="mb-8">
                <div className="flex items-center justify-between mb-4">
                  <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
                    Your Apps
                  </h4>
                  <span className="text-xs text-gray-400">
                    {filterModule.filter(app => app.isActive).length} active
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-3 overflow-y-auto pb-14 max-h-96">
                  {filterModule
                    .filter((app) => app.isActive)
                    .sort((a, b) => b.popularity - a.popularity)
                    .map((app, index) => (
                      <button
                        key={index}
                        onClick={() => handleAppClick(app)}
                        onMouseEnter={() => setHoveredApp(index)}
                        onMouseLeave={() => setHoveredApp(null)}
                        className="w-full flex flex-col items-center gap-4 p-4 rounded-xl border hover:border-gray-300 hover:shadow-md transition-all duration-200 text-left group relative overflow-hidden"
                      >
                        <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${app.color} shadow-sm group-hover:scale-110 transition-transform duration-200`}>
                          <img
                            src={app.image}
                            alt={app.label}
                            className="w-6 h-6 filter brightness-0 invert"
                          />
                        </div>
                        <div className="flex flex-col text-center items-center">
                          <div className="flex items-center gap-2">
                            <span className="text-gray-800 ">{app.label}</span>
                          </div>
                      
                          <div className="flex items-center gap-2 mt-1">
                            <span className="text-xs text-gray-400">{app.category}</span>
                          </div>
                        </div>
                        </button>
                    ))}
                </div>
              </div>

            </div>
          )}

          {/* Support Section */}
          {activeSection === "support" && (
            <div className="p-6">
              <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                Help & Support
              </h4>
              <div className="space-y-3">
                {supportItems.map((item, index) => (
                  <button
                    key={index}
                    onClick={() => handleNavigation(item.navigate)}
                    className="w-full flex items-center gap-3 p-4 rounded-xl hover:bg-gray-50 transition-all duration-200 text-left group border border-transparent hover:border-gray-200"
                  >
                    <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-gray-100 group-hover:bg-gray-200 transition-colors duration-200">
                      {item.icon}
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span className="text-gray-800 font-medium">{item.label}</span>
                        {item.badge && (
                          <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
                            {item.badge}
                          </span>
                        )}
                      </div>
                      <p className="text-sm text-gray-500">{item.description}</p>
                    </div>
                    <MdKeyboardArrowRight className="text-gray-400 group-hover:text-gray-600 transition-colors duration-200" />
                  </button>
                ))}
              </div>
            </div>
          )}

        
       
        </div>
      </div>
    </>
  );
};

export default UserNavigationSystem;